import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {ThemeModeProvider} from '../_metronic/partials'
import AuthProvider from './modules/auth/components/AuthProvider'
import { LocaleProvider } from './common/i18n/I18n'

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <LocaleProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <AuthProvider>
              <Outlet />
              <MasterInit />
            </AuthProvider>
          </ThemeModeProvider>
        </LayoutProvider>
      </LocaleProvider>
    </Suspense>
  )
}

export {App}
